var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('xm-overlay',{attrs:{"show":_vm.mutableShow}}),_vm._v(" "),_c('transition',{attrs:{"name":"xm-popover"}},[(_vm.mutableShow)?_c('div',{ref:"popover",class:'xm-popover ' + _vm.computedPosition,style:({ top: _vm.top+'px', left: _vm.left+'px'})},[_c('div',{staticClass:"angle"}),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._t("default")],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0b2420e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Popover.vue
// module id = 1388
// module chunks = 191